import { IAssetMetadata } from "../..";
import { MediaType } from "../../../types";
import { PixabayImageItem } from "../types";
import { BasePixabayAsset, deriveImageName } from "./base";

export class ImageAsset extends BasePixabayAsset {
  private item: PixabayImageItem;

  constructor(item: PixabayImageItem) {
    super(item.pageURL, item.tags, item.user, item.likes, item.downloads);
    this.item = item;
  }

  getName(): string {
    return deriveImageName(this.item.pageURL);
  }

  getMediaType(): MediaType {
    return MediaType.Image;
  }

  getImageUrlForCard(): string {
    return this.item.webformatURL;
  }

  getPreviewUrl(): string {
    return this.item.webformatURL;
  }

  getDownloadUrl(): string {
    return this.item.largeImageURL;
  }

  async downloadFile(): Promise<{ blob: Blob; filename: string }> {
    const response = await fetch(this.item.largeImageURL);
    if (!response.ok) throw new Error(`Failed to download Pixabay image: ${response.statusText}`);
    const blob = await response.blob();
    const ext = this.item.largeImageURL.split('.').pop()?.split('?')[0] ?? 'jpg';
    return { blob, filename: `${this.getName()}.${ext}` };
  }

  getMetadata(): IAssetMetadata {
    return {
      status: 'ready',
      date: '',
      size: this.item.imageSize,
      licence: 'Pixabay-licence',
      licenceUrl: 'https://pixabay.com/service/license-summary/',
      author: [this.item.user],
      tags: this.tags,
      categories: [],
      dimensions: `${this.item.imageWidth} x ${this.item.imageHeight}`,
      downloads: this.item.downloads,
      views: this.item.views,
      type: this.item.type,
    };
  }
}
